import { CartProductCode, CurrentPayPlan, IMonthlyPaymentDetail } from '@ace-clublabs/common-membership-api-types';
import { IMemberDetails, IState } from './model';
import { STATE_KEY } from './state';
import { initialState } from './stubs';

export const autoPayBillPlans = [
  CurrentPayPlan.RECURRINGCREDITORDEBITCARD,
  CurrentPayPlan.RECURRINGELECTRONICCHECK,
  CurrentPayPlan.RECURRINGMONTHLY,
];

export const annualAutoPayBillPlans = [
  CurrentPayPlan.RECURRINGCREDITORDEBITCARD,
  CurrentPayPlan.RECURRINGELECTRONICCHECK,
];

export const isAutopayBillPlan = (billPlan: CurrentPayPlan): boolean => {
  return autoPayBillPlans.includes(billPlan);
};

export const isOnAnnualAutopayBillPlan = (billPlan: CurrentPayPlan): boolean => {
  return annualAutoPayBillPlans.includes(billPlan);
};

export const isOnMonthlyBillPlan = (billPlan: CurrentPayPlan): boolean => {
  return billPlan === CurrentPayPlan.RECURRINGMONTHLY;
};

export const getOrderedMonthlyPayments = (monthlyPayments: IMonthlyPaymentDetail[]): IMonthlyPaymentDetail[] => {
  return monthlyPayments.sort((a, b) => {
    //@ts-ignore
    return new Date(a.dueDate) - new Date(b.dueDate);
  });
};

export const getJestStateObj = (mockState: IState) => {
  const keys = Object.keys(mockState);

  const jestStateObj = {} as any;

  for (let key of keys) {
    jestStateObj[key] = [mockState[key as keyof IState]];
  }

  return jestStateObj;
};

export const getLoggedInMember = (memberDetails: IMemberDetails) => {
  return memberDetails.members?.find((mem) => mem.customerId === memberDetails.loggedInCustomerId);
};

// export const generateInitialFormData = (memberDetails: IMemberDetails) => {
//   const formData: IFormData = {
//     requestedBillPlan: memberDetails?.currentBillPlan,
//     requestedMembershipLevel: memberDetails?.benefitLevels?.existingLevel,
//     members: JSON.parse(JSON.stringify(memberDetails?.members || [])),
//     products: JSON.parse(JSON.stringify(memberDetails?.products || [])),
//   };

//   return formData;
// };

export const getTodayPacificTimeDateObj = (): Date => {
  const options: any = { timeZone: 'America/Los_Angeles', year: 'numeric', month: 'numeric', day: 'numeric' };
  const formatter = new Intl.DateTimeFormat('en-US', options);

  const now = new Date();
  const formattedToday = formatter.format(now);

  const todayPacific = new Date(formattedToday);

  return todayPacific;
};

export const isPastDue = (dueDateStr: string): boolean => {
  const dueDate = new Date(dueDateStr);
  const todayInPacificTime = getTodayPacificTimeDateObj();

  return todayInPacificTime > dueDate;
};

export const isLaterThanDay = (dueDateStr: string): boolean => {
  const dueDate = new Date(dueDateStr);
  const todayInPacificTime = getTodayPacificTimeDateObj();

  return todayInPacificTime < dueDate;
};

export function getCartProductName<CartProductCode>(value: any): keyof CartProductCode {
  // @ts-ignore
  const keys = Object.keys(CartProductCode).filter((key) => CartProductCode[key as keyof CartProductCode] === value);
  return keys[0] as keyof CartProductCode;
}

export const deleteSessionState = () => {
  sessionStorage.removeItem(STATE_KEY);
};

export const clearGlobalState = (
  setGlobalState: <StateKey_2 extends keyof IState>(
    stateKey: StateKey_2,
    update: React.SetStateAction<IState[StateKey_2]>
  ) => void
) => {
  for (const stateKey in initialState) {
    const stateVariable = stateKey as keyof IState;
    setGlobalState(stateVariable, initialState[stateVariable]);
  }
};
